import "@fontsource-variable/bricolage-grotesque/opsz.css";
import "@fontsource-variable/figtree/index.css";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/pdv.css";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { z } from "zod";
import { ErroApi } from "./api/cliente";
import { CHAVE_SESSAO } from "./api/sessao";
import { ProvedorToast } from "./components/Toast";
import { esquecerTudo } from "./offline/ultimoConhecido";
import { roteador } from "./rotas";

z.config(z.locales.ptBR());

// Sessão expirada ou troca de senha exigida em qualquer chamada: revalida a sessão,
// e as rotas protegidas mandam para o login ou para a troca de senha.
const aoErrar = (erro: unknown) => {
  if (!(erro instanceof ErroApi)) return;
  // Só sessão inválida leva ao login. Um 401 de senha errada numa autorização de ADMIN
  // (cancelamento, exclusão) não pode deslogar quem está usando o aparelho.
  if (erro.status === 401 && erro.codigo === "NAO_AUTENTICADO") {
    esquecerTudo();
    clienteQuery.setQueryData(CHAVE_SESSAO, null);
  }
  if (erro.codigo === "TROCA_DE_SENHA_OBRIGATORIA") clienteQuery.invalidateQueries({ queryKey: CHAVE_SESSAO });
};

const clienteQuery = new QueryClient({
  queryCache: new QueryCache({ onError: aoErrar }),
  mutationCache: new MutationCache({ onError: aoErrar }),
  defaultOptions: {
    queries: {
      retry: (tentativas, erro) => !(erro instanceof ErroApi && erro.status >= 400 && erro.status < 500) && tentativas < 2,
      refetchOnWindowFocus: false,
    },
  },
});

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("Elemento #raiz não encontrado");

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={clienteQuery}>
      <ProvedorToast>
        <RouterProvider router={roteador} />
      </ProvedorToast>
    </QueryClientProvider>
  </StrictMode>,
);
